<template>
<div  class="container-fluid" >
  
  
  <div class="card ">
  
  <div class="card-header text-white  bg-primary">    
      <h4>
        <i style="color:yellow" class="fas fa-file-export mr-2" aria-hidden="true"></i>ASSOCIAZIONE EAN FORNITORE DA FILE</h4>    
  </div>
  
  <div class="card-body"> 
  
   <div class="row">
   <div class="col"> 

   <div class="card border-info" >
   <div class="card-header bg-info text-white">
    <i style="color:yellow" class="fas fa-upload mr-2" aria-hidden="true"></i>    
  <strong>CARICAMENTO FILE</strong></div>


  <div class="card-body text-info">
  <div class="form-group ">
        
    <input-file v-bind:type="'EanSupplierUpdate'"  @update="setData"></input-file> 

  </div> 

<div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

<table class="table table-hover table-sm table-striped mb-0">
  <thead >
    <tr class="table-primary">
      
      <th scope="col">#</th>
      <th scope="col">BARCODE GESTIONALE</th>
      <th scope="col">EAN FORNITORE</th>
      
    </tr>
  </thead>
  <tbody>
    
    <tr data-toggle="tooltip"  class="pointer" v-for="(item, index) in items" :key="index">
      <td>{{index+1}}</td>
      <td>{{item.barcode}}</td>
      <td>{{item.ean}}</td>
            
    </tr>     
  </tbody>
  
</table>
</div>



  </div>

  <div class="card-footer bg-transparent border-success">
    <button type="button" :disabled="items.length==0 || bt_spinner == true "  @click="saveData()" class="btn btn-primary float-right">  
   ESEGUI AGGIORNAMENTO EAN
    <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
    <i v-else style="color:yellow" class="far fa-check-circle ml-3" aria-hidden="true"></i>
</button>

    
    </div>

  </div>
  </div>

  <div class="col">

</div>  

</div>

</div>


</div>


    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
    </confirm-box>

</div>


</template>
<script>

import api               from "@/api";

import confirmBox        from '@/components/common/ConfirmBox.vue';
import inputFile         from '@/components/common/InputFile.vue';
import {mapGetters }     from 'vuex';


export default {

  
  components  : {confirmBox,inputFile},

  data() {
    return {
    
    items                  : [],

    bt_spinner             : false, 
    cb                     : {title : '',msg1 : '',show:false},
       
     
    }
  },
  computed :{
   
     ...mapGetters(['company']),

          
  },

    
  methods: {
 
   setData(items)
   {
        this.items = items
    },
    
  
    async saveData() {
    
      this.cb.title = ''

      this.bt_spinner = true
      
      
      const data = {'companyId' : this.company.Id,'body' : this.items}
      const sp = {'sp' : 'spEanSupplierUpdateFromFile'}
      
      const json    = Object.assign(data, sp)

         await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
              
              this.cb.title = "AGGIORNAMENTO EAN FORNITORE"
              this.cb.msg1  = "Registrazione effettuata."
              this.items    = []
              this.cb.show  = true
        
        
            }
          
          else
          {
            this.cb.title = 'ATTENZIONE '
            if(res.statusText)  
            {
              console.log('ERROR ')
              this.cb.msg1  = res.statusText
            }
            else
            {
              console.log('GENERIC ERR')
              this.cb.msg1  = res  
            }
              this.cb.show  = true
            
          }
      }).catch(err=>{
        
            
            console.log(err.message) 
            this.cb.title = 'ATTENZIONE '
            this.cb.msg1  = err.message
            this.cb.show  = true
            

      })
      
      this.bt_spinner = false
      
    }

  }
};
</script>
<style scoped>









h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 
 

</style>